// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

import "trix"
import "@rails/actiontext"

// A form submitted inside the modal frame that succeeds responds with a redirect to a
// full page (which has no "modal" frame). Rather than showing "Content missing",
// follow the redirect as a normal page visit. Validation errors re-render inside the modal.
document.addEventListener("turbo:frame-missing", (event) => {
  if (event.target.id !== "modal") return

  event.preventDefault()
  event.detail.visit(event.detail.response)
})

// Don't let an open modal end up in Turbo's page cache.
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll(".modal.show").forEach((el) => bootstrap.Modal.getInstance(el)?.dispose())
  document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
  document.body.classList.remove("modal-open")
  document.body.style.removeProperty("overflow")
  document.body.style.removeProperty("padding-right")
  const frame = document.getElementById("modal")
  if (frame) frame.innerHTML = ""
})
